import { Flex, Heading, Text } from "@radix-ui/themes";
import { BrandLogo } from "../../../components/brand-logo";
import { LangSelector } from "../../../views/mobile-app-checkout/lang-selector";

export function KioskUnavailable({
  permissionDenied = false,
}: {
  permissionDenied?: boolean;
}) {
  return (
    <main className="h-dvh bg-white p-6 mobile-fa select-none">
      <Flex justify="between">
        <BrandLogo />
        <LangSelector />
      </Flex>
      <Flex
        direction="column"
        align="center"
        justify="center"
        gap="3"
        className="h-[calc(100%-3rem)] pb-16"
      >
        <img src="/warning.webp" className="size-[190px]" alt="" />
        <Heading size="9">Temporarily out of service</Heading>
        <Text size="7" color="gray" align="center">
          {permissionDenied
            ? "Staff authorization is required."
            : "We will be back soon."}
        </Text>
      </Flex>
    </main>
  );
}
